import { FC, useCallback, useEffect, useState } from 'react';

import { ChatLauncher } from 'modules/webchat/presentation/components/atoms';
import { useWebchat } from 'modules/webchat/presentation/contexts/WebchatContext';

import PreChatModal from '../PreChatModal';

/**
 * Nosso botão de chat até o launcher do widget aparecer. Para o visitante
 * que ainda não se identificou, ele abre o pré-chat; com cliente logado ou
 * visitante já identificado, ele fica no lugar do launcher enquanto o widget
 * carrega e abre o chat assim que o widget fica pronto. Se o widget falhar,
 * o botão some e o StoreFooter volta a mostrar o WhatsApp.
 */
const WebchatPreChat: FC = () => {
  const { isAvailable, identity, status, openWebchat } = useWebchat();
  const [isPreChatOpen, setIsPreChatOpen] = useState(false);

  const closePreChat = useCallback(() => setIsPreChatOpen(false), []);

  useEffect(() => {
    // Rota bloqueada (câmera, totem) no meio do pré-chat: o modal não fica por cima.
    if (!isAvailable) closePreChat();
  }, [closePreChat, isAvailable]);

  const handleLauncherClick = useCallback(() => {
    if (identity) {
      openWebchat();

      return;
    }

    setIsPreChatOpen(true);
  }, [identity, openWebchat]);

  const isWidgetPending = status === 'idle' || status === 'loading';
  const shouldShowLauncher = isAvailable && isWidgetPending && !isPreChatOpen;

  return (
    <>
      {shouldShowLauncher && <ChatLauncher onClick={handleLauncherClick} />}

      {isPreChatOpen && <PreChatModal onClose={closePreChat} />}
    </>
  );
};

export default WebchatPreChat;
